import { Flex } from '@grupoboticario/flora-react';
import { ExclamationMarkHexagonIcon } from '@grupoboticario/flora-react-icons';
import { theme } from 'ui/theme';

import { ErrorBannerProps } from './ErrorBanner.d';
import ErrorBannerStyles from './ErrorBanner.styles';

export const ErrorBanner = ({ title, subtitle }: ErrorBannerProps) => (
  <ErrorBannerStyles.Component data-testid="erro-banner">
    <Flex justify="center">
      <ExclamationMarkHexagonIcon
        css={{ color: theme.colors.action.nonInteractive.emphasis }}
        size="64"
      />
    </Flex>
    <ErrorBannerStyles.Text>
      <ErrorBannerStyles.Title variant="body-large-standard">{title}</ErrorBannerStyles.Title>
      {subtitle && (
        <ErrorBannerStyles.SubTitle variant="body-medium-standard">
          {subtitle}
        </ErrorBannerStyles.SubTitle>
      )}
    </ErrorBannerStyles.Text>
  </ErrorBannerStyles.Component>
);
